// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MyCompany from "../containers/companies/MyCompany";

class Company extends Component<*> {
  render(): * {
    return (
      <UserAuth
        oneOfPrincipalList={["company_children_write", "company_children_read"]}
        unAuthChildren={<RedirectoLogin />}
      >
        <div className="app-main">
          <MyCompany />
        </div>
      </UserAuth>
    );
  }
}

export default Company;
